import SessionService from "../../../shared/services/sessionService";
import ApiService from "../../../shared/services/apiService";
import { API_ENDPOINT } from "../../../shared/types/enums";

export default class ReportSettingsService {
    static getReportFilters = (_tenantId, _reportId) => {
        return ApiService.getOBS(API_ENDPOINT.REPORTS, `/Reports/FetchReportFilters/${_tenantId}/${_reportId}`);
    }

    static getLanguagesByReportId = (_tenantId, _reportId, _languages) => {
        return ApiService.getOBS(API_ENDPOINT.REPORTS, `/Reports/FetchLanguagesByReportId?tenantId=${_tenantId}&reportId=${_reportId}&languages=${_languages}`);
    };


    static getReportSaveFileTypes = () => {
        return ApiService.getOBS(API_ENDPOINT.REPORTS, `/Reports/FetchReportSaveFileTypes`);
    };
}